import * as rd from '@devexperts/remote-data-ts'
import { BookingPeriod } from '@spiaggeit/spit-datepicker'
import { cn } from '@spiaggeit/spit-ui'
import { t } from 'i18next'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router-dom'

import { Calendar } from '@/assets/icons/Calendar'
import {
  CHOOSE_PRODUCT_PATH,
  INSERT_DATA_PATH,
  INSERT_INSURANCE_PATH,
  INSERT_PERIOD_PATH,
  MAP_PATH,
  SECTOR_PATH,
  TICKETS_PATH,
} from '@/app/router/paths'
import { useAppSelector } from '@/hooks/store'
import { useCurrentPath } from '@/hooks/useCurrentPath'
import {
  bookingPeriodSelector,
  dateStringSelector,
} from '@/store/insertPeriodSlice'
import { licenseSlice } from '@/store/licenseSlice'

type Props = {
  className?: string
}

const TIME_ZONE = 'utc'
export const InsertPeriodLink = memo(function InsertPeriodLink(props: Props) {
  const { i18n } = useTranslation()
  const { currentPath } = useCurrentPath()
  const license = useAppSelector(licenseSlice.selectors.licenseRemoteData)
  const bookingPeriod = useAppSelector(bookingPeriodSelector)
  const dateString = useAppSelector((state) =>
    dateStringSelector(state, i18n.language, TIME_ZONE)
  )

  if (
    !rd.isSuccess(license) ||
    !dateString ||
    ![
      CHOOSE_PRODUCT_PATH,
      INSERT_INSURANCE_PATH,
      INSERT_DATA_PATH,
      TICKETS_PATH,
      SECTOR_PATH,
      MAP_PATH,
    ].includes(currentPath)
  ) {
    return null
  }

  const isBookingPeriodHalfDay =
    bookingPeriod === BookingPeriod.MORNING ||
    bookingPeriod === BookingPeriod.AFTERNOON
  const bookingPeriodString = t(`datepicker.bookingPeriod.${bookingPeriod}`)

  return (
    <Link
      className={cn(
        'flex shrink-0 select-none items-center gap-2 text-nowrap rounded-sm border bg-white px-3 py-2 text-sm font-bold text-primary transition-colors hover:border-gray-300',
        props.className
      )}
      to={`${generatePath(INSERT_PERIOD_PATH, {
        license: license.value.license.license,
      })}`}
    >
      <Calendar className="size-5" />

      {isBookingPeriodHalfDay
        ? `${dateString} · ${bookingPeriodString}`
        : dateString}
    </Link>
  )
})
